import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { ItemPackageSharing } from './work-center'

@Directive({
  selector: '[appItemPackageSharingSelect]',
})
export class ItemPackageSharingSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'packaging.itemPackageSharing.title'
    this.select.displayProperty = 'displayValue'
    this.select.dataSource = enumTranslationService.enumDataSource(
      ItemPackageSharing,
      'packaging.itemPackageSharing',
      false
    )
  }
}
